import { MoreVert } from '@material-ui/icons';
import styled from 'styled-components';
import { ChevronUp } from '../../../../common/components/icons/outlined/ChevronUp';
import { ThemeColours } from '../../../../common/styles/ThemeColours';
import { Breakpoint, ZIndex } from '../../../../common/styles/constants';
import { propSwitch } from '../../../../common/util/propSwitch';
import { SpecialtyIconWrapper, StyledSpecialtyButton } from '../SearchSpecialtySelector.styles';

export const SpecialtyOverflowMenuContainer = styled.div<{ experiment?: boolean }>`
  background-color: ${ThemeColours.white};
  border-radius: 8px;
  box-shadow: 0px 1px 10px rgb(7 35 38 / 10%);
  flex-direction: column;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: ${props => (props.experiment ? 'calc(100% + 4px)' : 'calc(100% + 10px)')};
  width: 100%;
  z-index: ${ZIndex.POPUP};

  ${Breakpoint.SMALL} {
    top: calc(100% + 10px);
    width: auto;
  }
`;

export const SpecialtyOverflowMenuItem = styled.div<{ active: boolean }>`
  background-color: ${propSwitch('active', ThemeColours.primary500, 'none')};
  color: ${({ active }) => (active ? ThemeColours.white : ThemeColours.mono800)};
  cursor: pointer;
  padding: 12px 24px;
  transition: background-color 0.3s, color 0.3s;

  ${Breakpoint.SMALL} {
    padding: 12px;
  }

  &:hover {
    background-color: ${ThemeColours.mono100};
  }
`;

export const SpecialtyOverflowMenuIconWrapper = styled(SpecialtyIconWrapper)`
  background-color: transparent;
`;

export const SpecialtyOverflowMenuIcon = styled(MoreVert)`
  color: ${ThemeColours.primary500};
  font-size: 40px !important;
  width: auto;

  ${Breakpoint.SMALL} {
    min-width: auto;
  }
`;

export const SpecialtyOverflowMenuChevDown = styled(ChevronUp)<{
  $experiment?: boolean;
  open?: boolean;
}>`
  fill: ${ThemeColours.primary500};
  height: ${props => (props.$experiment ? '24px' : '32px')};
  margin-left: ${props => (props.$experiment ? 'initial' : 'auto')};
  padding-left: ${props => (props.$experiment ? '8px' : '0px')};
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0)')};
  transition: transform 0.3s;
  width: auto;

  ${Breakpoint.SMALL} {
    height: 17px;
    margin-left: initial;
    padding-left: 0px;
  }
`;

export const StyledOverflowSpecialtyButton = styled(StyledSpecialtyButton)`
  width: ${props => (props.experiment ? '150px' : 'auto')};

  ${Breakpoint.SMALL} {
    width: auto;
  }
`;
